import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Cosmetics from './views/Cosmetics.vue'
import SkinCare from './views/SkinCare.vue'
import BodyCare from './views/BodyCare.vue'
import productDetails from '@/views/productDetails.vue'
import Contact from '@/views/Contact.vue'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/cosmetics',
            name: 'cosmetics',
            component: Cosmetics
        },
        {
            path: '/skinCare',
            name: 'skinCare',
            component: SkinCare
        },
        {
            path: '/bodyCare',
            name: 'bodyCare',
            component: BodyCare
        },
        {
            path: '/details/:Pid',
            name: 'details',
            component: productDetails
        },
        {
            path: '/contact',
            name: 'contact',
            component: Contact
        }
    ],
    mode: 'history'
})
